import { Btn, Breadcrumbs, H4 } from '../../AbstractElements';
import React, { Fragment, useState, useCallback, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { dummytabledata, tableColumns } from '../../Data/DataTable/trip';
import axios from 'axios';
import { _axios } from '../../utils/axios'; 
import EditTrip from './EditTrip';
import AddTrip from './AddTrip';
import { Link } from 'react-router-dom';
import { ServerPath } from '../../Constant';
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';

const DataTablesContain = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${ServerPath}/tripdetails`);
        const actualData = response?.data.data;
        console.log(actualData);
        const userData = actualData.map(trip => ({
          ...trip,
          thumbnail: <img src={trip.thumbnail} alt="Thumbnail" width="45" height="45" />,
          trip_name: <div className="align-self-center"><div>{trip?.trip_name}</div></div>,
          location: <Link to={trip.location}>{trip.location}</Link>,
          status: <span
            className={`badge rounded-pill ${trip?.status === 1 ? 'badge-success' : 'badge-danger'}`}
            data-bs-toggle="modal"
            data-bs-target=".bd-example-modal-sm"
          >
            {trip?.status === 1 ? 'Active' : 'Inactive'}
          </span>,
          action: (
            <div className="action d-flex justify-content-center">
              <div className="edit" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                {trip && <EditTrip data={trip} />}
              </div>
              <div className="delete">
                <Button onClick={(e) => handleDeleteID(trip.journey_id, e)} className="btn-square btn btn-danger mx-2"><i className="icon-trash"></i></Button>
              </div>
            </div>
          ),
        }));
        setData(userData);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchData();
  }, []);

  const handleDeleteID = async (tripID, event) => {
    event.preventDefault();
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      customClass: {
        container: 'swal2-container'
      }
    });

    if (result.isConfirmed) {
      try {
        await _axios.delete(`${ServerPath}/tripdetails/${tripID}`);
        setData(prevData => prevData.filter(data => data.journey_id !== tripID));
        Swal.fire(
          'Deleted!',
          'Your trip details has been deleted.',
          'success'
        );
      } catch (error) {
        console.error('Error deleting trip details:', error);
        Swal.fire(
          'Error!',
          'There was an error deleting the trip details.',
          'error'
        );
      }
    }
  };

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map(r => r.title)}?`)) {
      setToggleDelet(!toggleDelet);
      setData(data.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
      setSelectedRows('');
    }
  };

  return (
    <Fragment>
      <div className='row'>
        <div className='col-12 col-md-6 col-lg-6'>
          <Breadcrumbs mainTitle="Trip" parent="Tables" title="Trip" />
        </div>
        <div className='col-12 col-md-6 col-lg-6'>
          <AddTrip />
        </div>
      </div>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className='pt-0'>
                {(selectedRows.length !== 0) &&
                  <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delete Selected Data?</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                  </div>
                }
                <DataTable
                  className='data-tables theme-scrollbar pt-4'
                  data={data}
                  columns={tableColumns}
                  striped={true}
                  center={true}
                  pagination
                  selectableRows
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleDelet}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );

};
export default DataTablesContain;